import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TasksListComponent } from "../TasksListComponent";
import { toast } from "react-toastify";

function TrashedTasks({
  setIsTrashOpen,
  setOnRender,
  isTrashOpen,
  onRender,
  isButtonDisable,
}) {
  const dispatch = useDispatch();
  const [trashedTasks, setTrashTasks] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [onSuccess, setOnSuccess] = useState(false);
  const [restoreLoading, setRestoreLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const DetailedProjectData = useSelector(
    (state) => state.projectDetails.getDetailedProjectData
  );

  useEffect(() => {
    const fetchData = async () => {
      const response = await dispatch.trashandStatus.getTrashedData();
      setTrashTasks(response.trash.task);
    };
    fetchData();
  }, [onSuccess, isTrashOpen]);

  const onSelectAll = () => {
    setAllSelected(true);
    const ids = trashedTasks.map((obj) => obj._id);
    setSelectedItems(ids);
  };

  const onUnselectAll = () => {
    setAllSelected(false);
    setSelectedItems([]);
  };

  const onDeletePermanent = async () => {
    setDeleteLoading(true);
    try {
      const response = await dispatch.trashandStatus.deleteTrashedData({
        trashId: selectedItems,
      });
      if (response.success) {
        toast.success(response.task);
        setOnSuccess(!onSuccess);
        setSelectedItems([]);
      } else {
        toast.error(response.task);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const onRestore = async () => {
    setRestoreLoading(true);
    try {
      const response = await dispatch.trashandStatus.restoreTrashedData({
        trashId: selectedItems,
        project_id: DetailedProjectData?.project?._id,
      });
      if (response.success) {
        toast.success(response.task);
        setSelectedItems([]);
        setOnRender(!onRender);
        setOnSuccess(!onSuccess);
      } else {
        toast.error(response.task);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setRestoreLoading(false);
    }
  };

  return (
    <div className="">
      <div
        className={`fixed inset-0 bg-theme-ink opacity-15 ${
          isTrashOpen ? "" : "hidden"
        } `}
        onClick={() => setIsTrashOpen(false)}
      />
      <div
        className={`fixed bottom-0 flex flex-col max-w-full bg-theme-paper bg-clip-padding shadow-theme-pop outline-none duration-500 text-theme-fg-2 top-0 right-0 border-none w-full md:w-[90%] z-50 pb-4 ${
          isTrashOpen
            ? "translate-x-0"
            : "opacity-0 pointer-events-none translate-x-full"
        }`}
      >
        <div
          className={`flex w-full justify-between py-[19px] px-6 border-b-[1px] ${
            isButtonDisable ? "mb-10" : ""
          } `}
        >
          <h5 className="text-base font-medium">Trash</h5>
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="cursor-pointer"
            onClick={() => {
              setIsTrashOpen(false);
            }}
          >
            <path
              d="M7.06127 6.39623L11.7801 1.36258C12.0733 1.05011 12.0733 0.543114 11.7801 0.230645C11.4869 -0.0820901 11.0122 -0.0820901 10.719 0.230645L6.00012 5.2643L1.28102 0.230645C0.987847 -0.0820901 0.51306 -0.0820901 0.219883 0.230645C-0.0732943 0.543114 -0.0732943 1.05011 0.219883 1.36258L4.93898 6.39623L0.219883 11.4299C-0.0732943 11.7423 -0.0732943 12.2493 0.219883 12.5618C0.366471 12.7179 0.558587 12.7961 0.750453 12.7961C0.942319 12.7961 1.13444 12.7179 1.28102 12.5615L6.00012 7.52789L10.719 12.5615C10.8656 12.7179 11.0577 12.7961 11.2495 12.7961C11.4414 12.7961 11.6335 12.7179 11.7801 12.5615C12.0733 12.2491 12.0733 11.7421 11.7801 11.4296L7.06127 6.39623Z"
              fill="#B4B4B4"
            />
          </svg>
        </div>
        {!isButtonDisable && (
          <div className="flex flex-col-reverse sm:flex-row w-full justify-between items-start sm:items-center py-5 lg:pr-10 pl-6 gap-4">
            {allSelected ? (
              <h4
                className="text-theme-avail-fg text-sm font-semibold cursor-pointer hover:underline"
                onClick={onUnselectAll}
              >
                Unselect All
              </h4>
            ) : (
              <h4
                className={`text-theme-avail-fg text-sm font-semibold cursor-pointer hover:underline ${
                  trashedTasks.length == 0 ? "opacity-20" : "opacity-100"
                }`}
                onClick={trashedTasks.length == 0 ? null : onSelectAll}
              >
                Select All
              </h4>
            )}
            <div className="flex gap-5">
              <button
                className={`bg-theme-cream-3 cursor-pointer flex px-3 py-2 rounded-full items-center justify-center gap-2 text-theme-avail-fg text-xs font-medium ${
                  selectedItems.length == 0 ? "opacity-20" : "opacity-100"
                }`}
                onClick={selectedItems.length === 0 ? null : onRestore}
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.5557 2.4502H0.5M10.4716 4.07603L10.1724 8.56333C10.0573 10.2893 10.0001 11.1523 9.43753 11.6784C8.87499 12.2045 8.0094 12.2052 6.27951 12.2052H5.77615C4.04627 12.2052 3.18067 12.2052 2.61814 11.6784C2.0556 11.1523 1.99772 10.2893 1.88326 8.56333L1.58411 4.07603"
                    stroke="#0C7A5A"
                    stroke-linecap="round"
                  />
                  <path
                    d="M2.45068 2.451H2.52222C2.78394 2.44431 3.03756 2.3588 3.24989 2.20564C3.46223 2.05248 3.6234 1.8388 3.71233 1.59256L3.73444 1.52558L3.79752 1.33633C3.8515 1.1744 3.87882 1.09375 3.91458 1.02482C3.98495 0.889803 4.08595 0.773134 4.20949 0.684148C4.33304 0.595161 4.47569 0.536328 4.62605 0.512356C4.70214 0.5 4.78733 0.5 4.95772 0.5H7.09731C7.2677 0.5 7.35289 0.5 7.42898 0.512356C7.57934 0.536328 7.722 0.595161 7.84554 0.684148C7.96908 0.773134 8.07008 0.889803 8.14045 1.02482C8.17622 1.09375 8.20353 1.1744 8.25751 1.33633L8.32059 1.52558C8.40301 1.79954 8.57345 2.03869 8.80553 2.20599C9.03761 2.37329 9.31838 2.45941 9.60435 2.451"
                    stroke="#0C7A5A"
                  />
                </svg>

                {restoreLoading ? "Loading.." : "Restore"}
              </button>
              <button
                className={`flex items-center cursor-pointer ${
                  deleteLoading ? "justify-start" : "justify-center"
                } gap-2 text-theme-full-fg text-xs font-medium px-3 py-2 w-44 rounded-full border-theme-cream-3 border-4 ${
                  selectedItems.length == 0 ? "opacity-20" : "opacity-100"
                }`}
                onClick={selectedItems.length === 0 ? null : onDeletePermanent}
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.5557 2.4502H0.5M10.4716 4.07603L10.1724 8.56333C10.0573 10.2893 10.0001 11.1523 9.43753 11.6784C8.87499 12.2045 8.0094 12.2052 6.27951 12.2052H5.77615C4.04627 12.2052 3.18067 12.2052 2.61814 11.6784C2.0556 11.1523 1.99772 10.2893 1.88326 8.56333L1.58411 4.07603"
                    stroke="#C53030"
                    stroke-linecap="round"
                  />
                  <path
                    d="M2.45068 2.451H2.52222C2.78394 2.44431 3.03756 2.3588 3.24989 2.20564C3.46223 2.05248 3.6234 1.8388 3.71233 1.59256L3.73444 1.52558L3.79752 1.33633C3.8515 1.1744 3.87882 1.09375 3.91458 1.02482C3.98495 0.889803 4.08595 0.773134 4.20949 0.684148C4.33304 0.595161 4.47569 0.536328 4.62605 0.512356C4.70214 0.5 4.78733 0.5 4.95772 0.5H7.09731C7.2677 0.5 7.35289 0.5 7.42898 0.512356C7.57934 0.536328 7.722 0.595161 7.84554 0.684148C7.96908 0.773134 8.07008 0.889803 8.14045 1.02482C8.17622 1.09375 8.20353 1.1744 8.25751 1.33633L8.32059 1.52558C8.40301 1.79954 8.57345 2.03869 8.80553 2.20599C9.03761 2.37329 9.31838 2.45941 9.60435 2.451"
                    stroke="#C53030"
                  />
                </svg>
                {deleteLoading ? "Loading..." : "Delete Permanently"}
              </button>
            </div>
          </div>
        )}
        <div className="overflow-y-auto lg:pr-10 xl:pr-32">
          {trashedTasks.length !== 0 ? (
            trashedTasks.map((task) => {
              const milestoneName =
                task.milestone_id.length !== 0
                  ? task?.milestone_id[0]?.title
                  : "null";
              return (
                <div
                  key={task._id}
                  className="flex justify-between px-5 lg:px-10 items-center w-full gap-4 overflow-x-hidden"
                >
                  <div className="w-full my-1">
                    <TasksListComponent
                      item={task}
                      milestoneName={milestoneName}
                      isTrashed={true}
                      selectedItems={selectedItems}
                      setSelectedItems={setSelectedItems}
                      isButtonDisable={isButtonDisable}
                    />
                  </div>
                  <div className="hidden md:flex items-center gap-1">
                    <svg
                      width="22"
                      height="16"
                      viewBox="0 0 22 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.5 7.75H15.5M15.5 7.75L12.75 10.5M15.5 7.75L12.75 5"
                        stroke="#C7CED9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M0.75 10.75V4.75C0.75 3.68913 1.17143 2.67172 1.92157 1.92157C2.67172 1.17143 3.68913 0.75 4.75 0.75H16.75C17.8109 0.75 18.8283 1.17143 19.5784 1.92157C20.3286 2.67172 20.75 3.68913 20.75 4.75V10.75C20.75 11.8109 20.3286 12.8283 19.5784 13.5784C18.8283 14.3286 17.8109 14.75 16.75 14.75H4.75C3.68913 14.75 2.67172 14.3286 1.92157 13.5784C1.17143 12.8283 0.75 11.8109 0.75 10.75Z"
                        stroke="#C7CED9"
                        stroke-width="1.5"
                      />
                    </svg>

                    <p className="pl-2 whitespace-nowrap">{milestoneName}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-center py-16 font-medium opacity-75">
              No Trashed Tasks
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default TrashedTasks;
